import React from "react";
// import RowComponent from "../RowHtml";
// import Video from "../Video";
import "./styles.scss";
import clsx from "clsx";
import OneVideo from "../OneVideo";
const MainVideo = (props) => {
  // const [currentVideoUrl, setCurrentVideoUrl] = useState(null);
  // const handleVideoClick = (url) => {
  //   setCurrentVideoUrl(url);
  // };
  const { video, className, isFullScreen = false } = props;
  // const { videoUrl } = props;
  const title = video?.[0]?.title;
  const shouldRenderTitle = !!title;
  const link = video?.[0]?.link;
  const shouldRenderLink = !!link;
  return (
    <div
      className={clsx(
        "OuterVideo MainVideo",
        className,
        isFullScreen ? "full-screen" : ""
      )}
    >
      <div className="player-wrapper">
        <OneVideo
          video={video?.[0]}
          controls={false}
          loop={true}
          // currentVideoUrl={currentVideoUrl}
          // setCurrentVideoUrl={setCurrentVideoUrl}
          // handleVideoClick={handleVideoClick}
        />
        {/* <div className="video-panel flex-it flex-align-item-center flex-justify-center">
        <RowComponent />
      </div>
*/}
        <div className="link-component flex-it flex-align-item-center flex-justify-center">
          {shouldRenderLink && (
            <a
              className="checkout-btn"
              target="_blank"
              href={link}
              rel="noreferrer"
            >
              {shouldRenderTitle ? `Link to ${title}` : <></>}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default MainVideo;
